import React, { useState, useEffect, useRef, useCallback } from 'react';

import { dateService } from '../../../services/date';

import Carousel from './carousel';

const mockStrategies = [
  {
    name: 'Sephora 2021 Summer Skincare Launch Three Lines Of Text',
    rate: '15% CPA+',
    datetime_start: '2021-06-01',
    datetime_end: '2021-07-31',
  },
  {
    name: 'Sephora 2021 Summer Skincare Launch Three Lines Of Text',
    rate: '15% CPA+',
    datetime_start: '2021-06-01',
    datetime_end: '2021-07-31',
  },
  {
    name: 'Sephora 2021 Summer Skincare Launch Three Lines Of Text',
    rate: '15% CPA+',
    datetime_start: '2021-06-01',
    datetime_end: '2021-07-31',
  },
  {
    name: 'Sephora 2021 Summer Skincare Launch Three Lines Of Text',
    rate: '15% CPA+',
    datetime_start: '2021-06-01',
    datetime_end: '2021-07-31',
  },
  {
    name: 'Sephora 2021 Summer Skincare Launch Three Lines Of Text',
    rate: '15% CPA+',
    datetime_start: '2021-06-01',
    datetime_end: '2021-07-31',
  },
  {
    name: 'Sephora 2021 Summer Skincare Launch Three Lines Of Text',
    rate: '15% CPA+',
    datetime_start: '2021-06-01',
    datetime_end: '2021-07-31',
  },
  {
    name: 'Sephora 2021 Summer Skincare Launch Three Lines Of Text',
    rate: '15% CPA+',
    datetime_start: '2021-06-01',
    datetime_end: '2021-07-31',
  },
  {
    name: 'Sephora 2021 Summer Skincare Launch Three Lines Of Text',
    rate: '15% CPA+',
    datetime_start: '2021-06-01',
    datetime_end: '2021-07-31',
  },
];

const TrendingOffers = ({}) => {
  const [strategies, setStrategies] = useState(mockStrategies);

  const strategyItems = strategies.map((strategy, index) => {
    const start = strategy.datetime_start && dateService.formatDisplayDate(strategy.datetime_start);
    const startMonthDay = start.slice(0, start.length - 6);
    const end = strategy.datetime_end && dateService.formatDisplayDate(strategy.datetime_end);

    return (
      <div className="item" key={index}>
        <div className="number">{index + 1}</div>
        <img placeholder="strategy image" />
        <div className="info">
          <span className="name">{strategy.name}</span>
          <span className="rate">{strategy.rate}</span>
          <span className="datetime">
            {startMonthDay} - {end}
          </span>
        </div>
      </div>
    );
  });

  return (
    <div className="trending-offers">
      <div
        className="color-gradient"
        style={{ background: 'linear-gradient(45deg, #5A28A0, #D68194' }}
      >
        <div className="title">🔥 Trending on Narrativ</div>
        <Carousel>{strategyItems}</Carousel>
      </div>
    </div>
  );
};

export default TrendingOffers;
